import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import {
  SearchTenantsByBrandId,
  SearchTenantsByBrandIdVariables
} from "./types/SearchTenantsByBrandId";
export const searchTenantsByBrandId = gql`
  ${pageInfoFragment}
  query SearchTenantsByBrandId(
    $brand: [ID]!
    $status: SmopStatusEnum
    $after: String
    $first: Int!
    $query: String!
  ) {
    search: tenants(
      after: $after
      first: $first
      filter: { search: $query, brandId: $brand }
      status: $status
    ) {
      edges {
        node {
          id
          legalName
          storeName
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<
  SearchTenantsByBrandId,
  SearchTenantsByBrandIdVariables
>(searchTenantsByBrandId);
